import { css } from '@emotion/react';
import { CssVars, Modal, NeutralColorToken, SemanticColorToken, Type } from '@robinhood/design';
import { RowUtils } from '@robinhood/design/product/components/Rows/RowUtils';

import Button from 'src/components/creditApplication/Button';

interface PropsIface {
  onDismiss: () => void;
}

const IncomeModal = ({ onDismiss }: PropsIface) => {
  return (
    <Modal width='wide' overrideModalStyles={root} onClose={onDismiss}>
      <div>
        <div css={[dialogSection, { borderBottom: `1px solid ${CssVars.neutral.bg3}` }]}>
          <Type.Text size='M' isBold>
            Include all pre-tax income, like:
          </Type.Text>
          <div css={row}>
            <RowUtils.Icon type='BubbleChecked24' color={SemanticColorToken.Positive} />
            <Type.Text size='M'>Annual base salary</Type.Text>
          </div>
          <div css={row}>
            <RowUtils.Icon type='BubbleChecked24' color={SemanticColorToken.Positive} />
            <Type.Text size='M'>Annual bonus, if applicable</Type.Text>
          </div>
        </div>
        <div css={dialogSection}>
          <Type.Text size='M' isBold>
            Don’t include:
          </Type.Text>
          <div css={row}>
            <RowUtils.Icon type='BubbleRemoveFilled24' color={NeutralColorToken.Fg3} />
            <Type.Text size='M'>RSUs, stocks, or options</Type.Text>
          </div>
          <div css={row}>
            <RowUtils.Icon type='BubbleRemoveFilled24' color={NeutralColorToken.Fg3} />
            <Type.Text size='M'>Investment income</Type.Text>
          </div>
        </div>
        <div css={buttonContainer}>
          <Button label='Dismiss' width='full' type='button' onClick={onDismiss} />
        </div>
      </div>
    </Modal>
  );
};

const root = css`
  padding: 0px;
`;

const dialogSection = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

const row = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const buttonContainer = css`
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 40px;
`;

export default IncomeModal;
